<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout justify-center align-center>
        <v-card class="contact-container">
          <v-card-title>{{ $t("contact.contact") }}</v-card-title>
          <v-divider/>
          <v-card-text>
            <v-form v-model="valid" ref="form" lazy-validation>
              <v-container fluid>
                <v-layout wrap row>
                  <v-flex xs12 md5>
                    <v-text-field
                      color="primary"
                      :label="$t('contact.name')"
                      v-model="request.name"
                      :rules="rules"
                      required
                    />
                  </v-flex>
                  <v-flex xs12 md6 offset-md1>
                    <v-text-field
                      color="primary"
                      :label="$t('contact.email')"
                      v-model="request.email"
                      :rules="emailRules"
                      required
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :label="$t('contact.subject')"
                      v-model="request.subject"
                      :rules="rules"
                      counter="250"
                      required
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      name="input-7-1"
                      :label="$t('contact.message')"
                      v-model="request.content"
                      :rules="rules"
                      multi-line counter="2000"
                      required
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap mt-3>
                  <v-flex xs12 md6 lg6 xl6>
                    <recaptcha ref="recaptcha" :recaptchId="'contact_form'" @verify="submit"/>
                  </v-flex>
                  <v-flex xs12 md6 lg6 xl6>
                    <v-layout row wrap style="height: 100%" align-center>
                      <v-flex xs12 class="text-sm-center">
                        <v-btn color="primary" :loading="loading" :disabled="loading"
                               @click="validate" large>
                          <v-icon left>message</v-icon>
                          {{$t('contact.sendMessage')}}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap mt-2>
                  <v-flex d-flex xs12>
                    <v-alert class="pa-2" outlined color="success"
                             style="width: 100%"
                             icon="check_circle" :value="response.success">
                      {{ $t('contact.request.success') }}
                    </v-alert>
                    <v-alert class="pa-2" outlined color="error"
                             style="width: 100%"
                             icon="warning" :value="response.error">
                      {{ $t('contact.request.error') }}
                    </v-alert>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
  const Recaptcha = () => import('../components/contact/Recaptcha');

  export default {
    name: 'Contact',
    components: {
      Recaptcha,
    },
    data() {
      return {
        valid: undefined,
        request: {
          name: '',
          email: '',
          subject: '',
          content: '',
          reCaptchaToken: undefined
        },
        response: {
          success: false,
          error: false
        },
        rules: [
          v => !!v || this.$i18n.t('form.required')
        ],
        emailRules: [
          v => !!v || this.$i18n.t('form.required'),
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('form.email.valid')
        ],
        loading: false
      };
    },
    mounted() {
      this.globalEvents.$on('languageChanged', () => {
        this.$refs.form.resetValidation();
        this.rules = [
          v => !!v || this.$i18n.t('form.required')
        ];
        this.emailRules = [
          v => !!v || this.$i18n.t('form.required'),
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('form.email.valid')
        ];
      });
      if (this.$route.params.subject !== undefined
        && this.$route.params.subject === 'reference') {
        this.request.subject = this.$i18n.t('contact.reference');
      }
      if (this.$auth.ready() && this.$auth.check()) {
        this.request.name = this.$auth.user().firstName.concat(' ')
          .concat(this.$auth.user().lastName);
        this.request.email = this.$auth.user().email;
      }
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.$refs.recaptcha.execute();
        }
      },
      // send your recaptcha token to the server to verify it
      submit(response) {
        this.request.reCaptchaToken = response;
        const contactRequestDTO = {
          reCaptchaToken: response,
          messageDTO: {
            name: this.request.name,
            email: this.request.email,
            message: this.request.content,
            subject: this.request.subject,
            read: false
          }
        };
        this.$http.post('message', contactRequestDTO).then(
          () => {
            this.loading = false;
            this.response.success = true;
            this.$refs.form.reset();
          },
          () => {
            this.loading = false;
            this.response.error = true;
          },
        );
      },
    },
  };
</script>

<style lang="scss">
  @import "../assets/scss/variables";
  @import "../assets/scss/layout";

  .contact-container {
    margin-top: 60px;
    text-align: left;
    h1 {
      margin-bottom: 15px;
      color: $primary-text;
    }
    @include MQ(M) {
      min-width: 500px;
    }
    @include MQ(L) {
      min-width: 600px;
    }
    @include MQ(XL) {
      min-width: 700px;
    }
  }
</style>
